import React from 'react';

export default class Loader extends React.Component {
    render() {
        if (this.props.show) {
            return <div className="loader dark">
                <div className="ball-scale-ripple-multiple">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        }
        else {
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Loader.js